import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import { graphql } from '@apollo/client/react/hoc'
import { useApolloClient } from '@apollo/client'
import { Container, Row, Col } from 'reactstrap'

class Page404 extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Container fluid className="Page404">
                <Row>
                    <Col xs={{ size: 4, offset: 4 }} className="section-404">
                        <p>404</p>
                        <small>The page you requested could not found</small>
                        <br /><br /><Link className="btn btn-primary" to="/">Go To HomePage</Link>
                    </Col>
                </Row>
            </Container>
        )
    }
}


export default Page404
